import { useMemo } from "react";

export interface WorkflowSetupStepText {
  stepLabelText: string;
  titleText: string;
  subtitleText: string;
  boardNameLabelText: string;
  workflowSectionText: string;
  workflowHintText: string;
  workflowColumnsAriaLabel: string;
  templatesSectionText: string;
  templatesHintText: string;
  templatesAriaLabel: string;
  addColumnText: string;
  doneColumnLabelText: string;
  selectTemplateText: string;
  selectedText: string;
  newColumnText: string;
}

const readText = (t: (key: string) => string, key: string): string => t(key);

export const useWorkflowSetupStepText = (
  t: (key: string) => string,
): WorkflowSetupStepText =>
  useMemo(
    () => ({
      stepLabelText: readText(t, "wizard.step2.label"),
      titleText: readText(t, "wizard.step2.title"),
      subtitleText: readText(t, "wizard.step2.subtitle"),
      boardNameLabelText: readText(t, "wizard.step2.boardNameLabel"),
      workflowSectionText: readText(t, "wizard.step2.workflowSection"),
      workflowHintText: readText(t, "wizard.step2.workflowHint"),
      workflowColumnsAriaLabel: readText(t, "wizard.step2.workflowColumnsAriaLabel"),
      templatesSectionText: readText(t, "wizard.step2.templatesSection"),
      templatesAriaLabel: readText(t, "wizard.step2.templatesAriaLabel"),
      templatesHintText: readText(t, "wizard.step2.templatesHint"),
      addColumnText: readText(t, "wizard.step2.addColumn"),
      doneColumnLabelText: readText(t, "wizard.step2.doneColumnLabel"),
      selectTemplateText: readText(t, "wizard.step2.selectTemplate"),
      selectedText: readText(t, "wizard.step2.selected"),
      newColumnText: readText(t, "wizard.step2.newColumn"),
    }),
    [t],
  );
